import type { ProfileFeatureConfig } from './type';

export const profileFeatureConfig: Partial<ProfileFeatureConfig> = {
    loginManagement: { oidcReady: false, targetClientId: 'INT82482' },
};
